import { StepContext, StepContextType } from '@/context/StepContext';
import { useContext } from 'react';

export const useStep = (): StepContextType => {
	const context = useContext(StepContext);

	if (context === undefined) {
		throw new Error('Use the StepProvider first');
	}

	return context;
};
